import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { Divider, Popover } from "@mui/material";
import { useDialog } from "@hooks/shared/use-dialog";
import { FavouriteCollectionDialog } from "@components/shared/elements/favourites/components/favourite-collection-dialog/favourite-collection-dialog";
import { FavouriteHeader } from "./favourite-header";
import { FavouriteForm } from "./favourite-form";
import { FavouriteActions } from "./favourite-actions";
import { useFavouriteManager } from "../hooks/useFavouriteManager";

export const FavouritesPopover = (props) => {
  const {
    anchorEl,
    onClose,
    open = false,
    setIsFavourited,
    isNewFavourite = false,
    existingFavouriteId = null,
    ...other
  } = props;

  const { t } = useTranslation();
  const dialog = useDialog();

  const {
    favouriteName,
    setFavouriteName,
    selectedCollection,
    setSelectedCollection,
    existingFavourite,
    favouritesUserCollections,
    handleUpdate,
    handleDelete,
    fetchUserCollections,
  } = useFavouriteManager(open, setIsFavourited, onClose, existingFavouriteId);

  const handleCollectionChange = (e) => {
    const value = e.target.value;
    if (value === "create-new") {
      document.activeElement?.blur();
      dialog.handleOpen();
    } else {
      setSelectedCollection(value);
    }
  };

  const handleCollectionCreated = () => {
    dialog.handleClose();
    fetchUserCollections();
    toast.success(t("favourites.selectCollectionFromDropdown"));
  };

  return (
    <Popover
      data-testid="fav-popover"
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: "right",
        vertical: "bottom",
      }}
      disableScrollLock
      disableAutoFocus
      disableEnforceFocus
      transformOrigin={{
        horizontal: "right",
        vertical: "top",
      }}
      onClose={onClose}
      open={open}
      slotProps={{
        paper: { sx: { width: 380, paddingBottom: 1 } },
      }}
      {...other}
    >
      <FavouriteHeader
        isNewFavourite={isNewFavourite}
        existingFavourite={existingFavourite}
      />
      <Divider />
      <FavouriteForm
        favouriteName={favouriteName}
        onNameChange={setFavouriteName}
        selectedCollection={selectedCollection}
        onCollectionChange={handleCollectionChange}
        userCollections={favouritesUserCollections}
      />
      <Divider />
      <FavouriteActions
        onDone={handleUpdate}
        onRemove={handleDelete}
        existingFavourite={existingFavourite}
        disabled={!selectedCollection || !favouriteName.trim()}
      />

      <FavouriteCollectionDialog
        onClose={dialog.handleClose}
        onSubmit={handleCollectionCreated}
        open={dialog.open}
        isFromFavouritesButton={true} // Indicate it's from favourites button; helps to select which zustand store to use
      />
    </Popover>
  );
};

FavouritesPopover.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  setIsFavourited: PropTypes.func,
  isNewFavourite: PropTypes.bool,
  existingFavouriteId: PropTypes.number,
};
